import React from "react";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";

const FieldGroup = ({ id, label, validationState, ...props }) => (
  <FormGroup controlId={id} validationState={validationState}>
    <ControlLabel>{label}</ControlLabel>
    <FormControl {...props} />
  </FormGroup>
);

export default FieldGroup;



// WEBPACK FOOTER //
// ./src/components/FieldGroup.js